const config = {
  closable: true,
  width: 650,
  destroyOnClose: true,
  listConfig: {
    mode: 'default',
    dataSource: [],
  },
};

export const withConfig = (props) => {
  return {
    ...config,
    ...props,
  };
};
